// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"580":"e8e63067","884":"2b6972aa"}[chunkId] + ".css";
};